import { isAdminTokenExpired, useAuthStore } from '../stores/authStore';

class PublisherAuthError extends Error {
  constructor() {
    super('Сессия истекла. Войдите снова.');
    this.name = 'PublisherAuthError';
  }
}

function clearExpiredSession(): never {
  useAuthStore.getState().logout();
  throw new PublisherAuthError();
}

export async function publisherFetch(input: RequestInfo | URL, init: RequestInit = {}): Promise<Response> {
  const token = useAuthStore.getState().token;
  if (!token) {
    throw new PublisherAuthError();
  }

  if (isAdminTokenExpired(token)) {
    clearExpiredSession();
  }

  const headers = new Headers(init.headers ?? (input instanceof Request ? input.headers : undefined));
  if (!headers.has('Authorization')) {
    headers.set('Authorization', `Bearer ${token}`);
  }

  const response = input instanceof Request
    ? await fetch(new Request(input, { ...init, headers }))
    : await fetch(input, { ...init, headers });

  if (response.status === 401) {
    clearExpiredSession();
  }

  return response;
}
